const SimpleTable = ({ data, columns }) => {
    if (!data || data.length === 0) return <p>No data available</p>;
    if (!columns || columns.length === 0) return <p>No columns defined</p>;

    return (
        <div className="max-h-[60vh] overflow-auto  border-gray-300 rounded overscroll-contain">

            <table className="min-w-full border border-gray-300 divide-y divide-gray-300">
                <thead className="bg-gray-100">
                    <tr>

                        {Object.entries(columns).map(([key, displayName]) => (
                            <th key={key} className="px-4 py-2 text-left text-sm font-semibold text-gray-700">
                                {displayName}
                            </th>
                        ))}
                    </tr>

                </thead>
                <tbody className="divide-y divide-gray-200">
                    {data.map((item, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                            {Object.keys(columns).map((key) => (
                                <td key={key} className="px-4 py-2 text-sm text-gray-600">
                                    {item[key] == 0 ? 'No' : (item[key] == '1' ? <span className="text-blue-500">Yes</span> : item[key])}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>


        </div>
    );
};

export default SimpleTable;